import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const inmatePostOfficeRoutes: RouteObject[] = [
  {
    path: '/mail-connect',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Mail Connect',
      crumb: () => ({ label: 'Mail Connect', to: '/mail-connect' })
    },
  },
  {
    path: '/mail-connect/scan',
    element: lazyElement(() => import('./Scan/Main')),
    handle: {
      documentTitle: 'Scanning',
      crumb: () => ({ label: 'Scanning', to: '/mail-connect/scan' })
    },
  },
];

export default inmatePostOfficeRoutes;
